import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanDeactivate, RouterStateSnapshot } from '@angular/router';
import { SetupSmsPingComponent } from '@app/two-way/setup/components/setup-sms-ping/setup-sms-ping.component';

/*
  Guard to prevent navigation away from the SetupSmsPingComponent
  if there are unsaved changes.
*/
@Injectable({ providedIn: 'root' })
export class UnsavedPingMessagesGuard implements CanDeactivate<SetupSmsPingComponent> {
    canDeactivate(
        component: SetupSmsPingComponent,
        _currentRoute: ActivatedRouteSnapshot,
        _currentState: RouterStateSnapshot,
        nextState?: RouterStateSnapshot,
    ) {
        return component.canDeactivate();
    }
}
